import type { FaireProductEntity } from "../../entity_types/product";

export const p_f45zjqaa7k: FaireProductEntity = {
  token: "p_f45zjqaa7k",
  type: "product",
  name: "Acrylic Hair Clips",
  brandToken: "b_6t4mvvvp2x",
  brandName: "The Sis Kiss",
  imageUrl:
    "https://cdn.faire.com/fastly/6f8f9140b099fb1b997d5d4a965f2ef554ecf7829cbbc4e2287aa1582a4d9bdf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63972c252522bdc4ccc92b69d0eb25d17514569a3d56382effd0875667437f7f.jpeg",
    "https://cdn.faire.com/fastly/f8620e4bde37a92c825a6b8efab795c041218d58433acda1b220a49756a8068b.jpeg",
    "https://cdn.faire.com/fastly/c6b8c8cca181f01515df22d3cca1cc831b257bc60f1dbc653edeeed229c6ded4.jpeg",
    "https://cdn.faire.com/fastly/6d5174d406edb3108764851452afa8d99b689590be7929b0440f21b0f06f359e.jpeg",
    "https://cdn.faire.com/fastly/7cb658940a527dd7b117dff1769bf6d33588a5347c8d6983c71c6f72a64d1c0d.jpeg",
    "https://cdn.faire.com/fastly/a857d3bbf37c59d3a686e0bf52b37e79f5220139a532db76f7a94e01f8adcb73.jpeg",
  ],
  priceDollars: 2.77,
  description:
    "Add some color to your glam sesh with these creaseless acrylic hair clips. Available in six colors!",
  tags: [],
  msrpDollars: 5.54,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:57.773Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
